<script setup lang="ts">
import type { CommunityPostItem } from '@/api/modules/communityPost'
import type { ProTableColumn } from '@/components/FaProTable/types'
import { FaButton } from '@fantastic-admin/components'
import AppStatusTag from '@/components/AppDisplay/StatusTag.vue'
import FaProTable from '@/components/FaProTable/index.vue'
import { formatDateTime } from '../../utils/userDisplay'

defineOptions({ name: 'UserContentTab' })

const props = defineProps<{ posts: { list: CommunityPostItem[], total: number }, canNavigate: boolean }>()
const emit = defineEmits<{ navigate: [] }>()

const columns: ProTableColumn<CommunityPostItem>[] = [
  { prop: 'id', label: '内容 ID', width: 90 },
  { prop: 'content', label: '内容摘要', minWidth: 320, formatter: row => row.content || '无文字内容' },
  { prop: 'audit_status', label: '审核', width: 110, render: ({ row }) => h(AppStatusTag, {
    label: Number(row.audit_status) === 1 ? '已通过' : Number(row.audit_status) === 2 ? '已驳回' : '审核中',
    tone: Number(row.audit_status) === 1 ? 'success' : Number(row.audit_status) === 2 ? 'danger' : 'warning',
  }) },
  { prop: 'like_count', label: '互动', width: 160, formatter: row => `赞 ${row.like_count || 0} / 评 ${row.comment_count || 0}` },
  { prop: 'created_at', label: '发布时间', width: 170, formatter: row => formatDateTime(row.created_at) },
]
</script>

<template>
  <FaCard title="内容记录" content-class="pt-3">
    <div class="mb-3 flex flex-wrap gap-3 items-center justify-between">
      <div class="text-sm text-muted-foreground">
        共 {{ props.posts.total }} 条动态，当前展示最近 10 条。
      </div>
      <FaButton v-if="props.canNavigate" variant="outline" size="sm" @click="emit('navigate')">
        进入内容正式列表
      </FaButton>
    </div>
    <FaProTable :columns="columns" :data="props.posts.list" :show-toolbar="false" :show-pagination="false" :bordered="false" :striped="false" row-key="id" />
  </FaCard>
</template>
